export const isChallengeConfirmationError = (error: Error) =>
  error.name === 'CONFIRMATION_ERROR';

export class ChallengeConfirmationError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'CONFIRMATION_ERROR';
  }
}
